import { default as React } from 'react';
import { makeStyles, Grid, Paper } from '@material-ui/core';
import { SkeletonBlock } from '../common/SkeletonBlock';

const useStyles = makeStyles(theme => ({
  contentRoot: {
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  headerSkeleton: {
    marginBottom: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(3),
    height: '100%',
  },
  cardHeader: {
    marginBottom: theme.spacing(2),
  },
  chartContainer: {
    height: 250,
    marginTop: theme.spacing(2),
  },
  tableRow: {
    display: 'flex',
    width: '100%',
    marginBottom: theme.spacing(1),
  },
  logsSection: {
    marginTop: theme.spacing(3),
  },
}));

interface BackstageLogsSkeletonProps {
  hideHeader?: boolean;
}

export const BackstageLogsSkeleton: React.FC<BackstageLogsSkeletonProps> = ({ hideHeader = false }) => {
  const classes = useStyles();

  return (
    <div className={classes.contentRoot}>
      {/* Header Toolbar Skeleton */}
      {!hideHeader && (
        <div className={classes.headerSkeleton}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={8}>
              <SkeletonBlock width="60%" height={40} />
            </Grid>
            <Grid item xs={4}>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <SkeletonBlock width={120} height={40} />
              </div>
            </Grid>
          </Grid>
        </div>
      )}

      {/* Chart + Top Errors Row */}
      <Grid container spacing={3}>
        {/* Chart Skeleton */}
        <Grid item xs={12} md={8}>
          <Paper className={classes.paper}>
            <div className={classes.cardHeader}>
              <SkeletonBlock width="40%" height={32} />
            </div>
            <div className={classes.chartContainer}>
              <SkeletonBlock height="100%" />
            </div>
          </Paper>
        </Grid>

        {/* Top 5 Errors Skeleton */}
        <Grid item xs={12} md={4}>
          <Paper className={classes.paper}>
            <div className={classes.cardHeader}>
              <SkeletonBlock width="70%" height={32} />
            </div>
            {Array(5).fill(0).map((_, i) => (
              <div key={i} className={classes.tableRow}>
                <SkeletonBlock height={24} />
              </div>
            ))}
          </Paper>
        </Grid>
      </Grid>

      {/* Logs Table Skeleton */}
      <div className={classes.logsSection}>
        <Paper className={classes.paper}>
          <div className={classes.cardHeader}>
            <SkeletonBlock width="25%" height={32} />
          </div>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <SkeletonBlock width="100%" height={40} />
            </Grid>
          </Grid>
          {Array(8).fill(0).map((_, i) => (
            <div key={i} className={classes.tableRow}>
              <SkeletonBlock height={32} />
            </div>
          ))}
        </Paper>
      </div>
    </div>
  );
};
